interface ScoreInputsProps {
	teamOneScore: number | '';
	teamTwoScore: number | '';
	onTeamOneChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onTeamTwoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	disabled?: boolean;
	tieBreakerRotatePlayerAfter: number;
}

export const ScoreInputs = ({
	teamOneScore,
	teamTwoScore,
	onTeamOneChange,
	onTeamTwoChange,
	disabled,
	tieBreakerRotatePlayerAfter
}: ScoreInputsProps) => (
	<div className="flex  flex-col items-center">
		<div className="flex gap-2">
			<input
				type="number"
				min={0}
				max={tieBreakerRotatePlayerAfter > 0 ? tieBreakerRotatePlayerAfter : 99}
				className="custom-number-input w-10 h-10 border border-darkorange-300 rounded-md text-center text-lg focus:outline-none focus:ring-2 focus:ring-darkorange-300"
				value={teamTwoScore}
				onChange={onTeamTwoChange}
				disabled={disabled}
			/>
			<input
				type="number"
				min={0}
				max={tieBreakerRotatePlayerAfter > 0 ? tieBreakerRotatePlayerAfter : 99}
				className="custom-number-input w-10 h-10 border border-darkorange-300 rounded-md text-center text-lg focus:outline-none focus:ring-2 focus:ring-darkorange-300"
				value={teamOneScore}
				onChange={onTeamOneChange}
				disabled={disabled}
			/>
		</div>
	</div>
);
